import React, { useState } from "react";
import { PhotoshopPicker, ColorResult } from "react-color";
import { hideContextMenu, showContextMenu } from "modules/common/services/context-menu";
import styles from "./ColorPicker.module.scss";
import { GeneralIcon } from "../planr/icon/Generalcon";

/**
 * Окно выбора цвета держит выбранный цвет само.
 *
 * С react-color 2.19 пикер управляемый: цвет он берёт из пропа на каждом рендере
 * (getDerivedStateFromProps) и без нового пропа возвращается к нему. Окно уходит в
 * контекстное меню один раз при открытии, поэтому состояние родителя до него не
 * доходит — цвет обновляется здесь, на каждое изменение, а не по onChangeComplete
 * (тот в 2.19 ещё и с задержкой).
 */
const PickerMenu = ({ initial, onAccept, onCancel }: PickerMenuProps) => {
    const [color, setColor] = useState(initial);

    return (
        <PhotoshopPicker
            header="Выбор цвета"
            color={color}
            onChange={(result: ColorResult) => setColor(result.hex)}
            onAccept={() => onAccept(color)}
            onCancel={onCancel}
        />
    );
};

export class ColorPicker extends React.PureComponent<ColorPickerProps, ColorPickerState> {
    constructor(props: ColorPickerProps) {
        super(props);

        this.state = { opened: false };
    }

    render() {
        const { color, className, small, readOnly } = this.props;

        return (
            <div
                className={`${styles.picker} ${!readOnly ? styles.active : ""} ${small ? styles.small : ""} ${
                    className || ""
                }`}
                style={{ backgroundColor: color, position: "relative" }}
                onClick={this.open}
            >
                <GeneralIcon type="general-palette" style={{ position: "absolute", right: "15px", top: "10px" }} />
            </div>
        );
    }

    menu = () => <PickerMenu initial={this.props.color} onAccept={this.colorAccepted} onCancel={() => this.close()} />;

    colorAccepted = (color: string) => {
        this.props.onSelected(color.toUpperCase());
        this.close();
    };

    private open = (e: React.MouseEvent<HTMLDivElement>) => {
        const { readOnly } = this.props;
        if (readOnly) {
            return;
        }

        this.setState({ opened: true });

        const menu = this.menu();

        showContextMenu({
            content: menu,
            targetOffset: { left: e.clientX, top: e.clientY },
            onClose: () => this.close(true),
        });
    };

    private close = (automatic: boolean = false) => {
        // в Blueprint 5 у императивного меню нет isOpen(); открытость мы и так знаем сами
        if (!automatic && this.state.opened) {
            hideContextMenu();
        }

        this.setState({ opened: false });
    };
}

interface ColorPickerProps {
    color: string;
    onSelected: (color: string) => void;
    className?: string;
    small?: boolean;
    readOnly?: boolean;
}

interface ColorPickerState {
    opened: boolean;
}

interface PickerMenuProps {
    initial: string;
    onAccept: (color: string) => void;
    onCancel: () => void;
}
